// extracted by mini-css-extract-plugin
module.exports = {"slide":"TabIncome_slide_rFC7q","slide-reverse":"TabIncome_slide-reverse_11lwz","innerTabStyle":"TabIncome_innerTabStyle_1LaWw"};